import { cn } from '@/lib/cn'

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded bg-surface-subtle', className)} aria-hidden />
}

/** 时间线加载时的占位，避免内容跳动 */
export function PostSkeleton() {
  return (
    <div className="flex gap-3 border-b border-line px-4 py-3">
      <Skeleton className="size-12 shrink-0 px-corners [--px-step:3px]" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    </div>
  )
}

export function PostListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div>
      {Array.from({ length: count }, (_, i) => (
        <PostSkeleton key={i} />
      ))}
    </div>
  )
}
